module.exports = __webpack_public_path__ + "0b6f45af0421b9e42d073dd04f8a26b7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-high-heels.png
// module id = 2432
// module chunks = 0